/* 居宅訪問 */
import * as React from 'react';
import KanaList from '../containers/KanaList';
import { userListHeader, UserSelectBody, Type } from './UserListField';
import * as PropTypes from 'prop-types';
import * as Header from '../constants/Header';
import 'react-bootstrap';
import '../common/css/reset.css';
import '../common/css/cmn_layout.css';
import '../common/css/cmn_style.css';
import '../css/locomo.css';
import '../css/calendar.css';
import '../css/print.css';

interface HomeVisitProps extends React.Props<{}> {
  moffAPI: any;
  appUser: any;
  moffAPIActions: any;
  appUserActions: any;
  headerActions?: any;
}

class HomeVisit extends React.Component<HomeVisitProps, {}> {
  // 親側の実装.
  static get childContextTypes() {
    return {
      callbackParent: PropTypes.func,
    };
  }

  static propTypes = {
    moffAPI: PropTypes.any.isRequired,
    moffAPIActions: PropTypes.any.isRequired,
    appUserActions: PropTypes.any.isRequired,
  };

  // 一覧から選択したユーザ.
  selectedUserId = '';

  componentWillMount() {
    document.title = '居宅訪問';

    this.props.headerActions.setPage(Header.HOME_VISIT);

    // Action
    this.props.moffAPIActions.getUsers();
  }

  /**
   * 各子のコンポーネントから呼ばれるcontext管理.
   *
   * @returns
   * @memberof HomeVisit
   */
  getChildContext() {
    const callback: Function = (userId: string) => {
      // 登録の確認Action.
      this.props.appUserActions.getAppUser(Type.HomeVisit, userId);
      this.selectedUserId = userId;
    };

    return {
      callbackParent: callback,
    };
  }

  /**
   *
   *
   * @returns
   * @memberof HomeVisit
   */
  render() {
    if (this.props.appUser.Loaded && this.props.appUser.result) {
      // 居宅訪問の詳細.
      window.location.href = `/home_visit_print/${this.props.appUser.result.total}/` +
        `${this.props.appUser.result.uniqueId}/${this.selectedUserId}`;
    }

    return (
      <div>
        <KanaList />
        {
          (() => {
            this.renderCSS();
             // 通常のAPI.
            if (this.props.moffAPI.Loaded
              // アプリユーザのAPI.
              && (this.props.appUser.Loaded === false && this.props.appUser.Loading === false) ||
              this.props.appUser.Loaded) {
              return;
            }
            // ローディング中
            return <div><div id="loader" /><div id="loader_back" /></div>;
          })()
        }
        <div id="userlist">
          <table className="tblStyle01">
            <thead>
              <tr>
                {userListHeader}
              </tr>
            </thead>
            <tbody>
            {(this.props.moffAPI.Loaded) ? 
              // ロードしたUserを表示.
              <UserSelectBody
                type={Type.HomeVisit}
                users={this.props.moffAPI.result}
              /> 
             :
              // ロード中.
              (null)
            }
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  /**
   * CSSの描画.
   *
   * @returns {JSX.Element}
   * @memberof MoffCheck
   */
  private renderCSS(): JSX.Element {
    return (
      <style key="locomoCSS"  type="text/css">
        {/* 縦印刷, 日付・title名ヘッダの余白 */}
        {'@media print{@page '
          + 'size: A4 landscape !important; '
          + 'margin-top: 5mm !important; '
          + 'margin-left: 1cm !important; '
          + 'margin-right: 1cm !important; '
          + 'margin-bottom: 5mm !important; } '
        }
      </style>
    );
  }
}

export default HomeVisit;



// WEBPACK FOOTER //
// ./src/components/HomeVisit.tsx